import api from 'services/inventory/part'
import { AutocompleteResult } from 'utils/types'

export const partAutocomplete = async (text: string): Promise<Array<AutocompleteResult>> => {
  if (!text) return []

  let res = await api.autocomplete({ text })

  if (!res?.data?.success) return []

  return res?.data?.data
}
